import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

export default function MultiDeleteComfirmation(props) {
    return (
        <Modal isOpen={props.isOpen} toggle={props.onToggle} style ={props.style}> 
            <ModalHeader toggle={props.onToggle}>{props.title}</ModalHeader>
            <ModalBody>
                {`Are you sure you want to delete the following records?`}

                <ul>
                    {getRows(props.toDelete)}
                </ul>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={props.onDelete}>Ok</Button>{' '}
                <Button color="secondary" onClick={props.onToggle}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
}

const getRows = (toDelete) => {
    const items = []
    toDelete && toDelete.forEach((x, i) => items.push(<li key={i}>{x}</li>));
    return items;
}